import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const deliveryCompanyList = async (searchType) => {
  const { data } = await axios.get(
    `${baseUrl}/shippingCompany/search?searchType=${searchType}`,
  );
  return data;
};

const salesManageStatus = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/readStatus`, {
    params: param,
  });
  return data;
};

const searchOrderGiftList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/detailList/search`, {
    params: param,
  });
  return data;
};

const searchOrderList = async (
  offset,
  pageSize,
  searchType,
  searchText,
  searchStatus,
  orderType,
  orderBy,
) => {
  const { data } = await axios.get(
    `${baseUrl}/userOrder/search?offset=${offset}&pageSize=${pageSize}&searchType=${searchType}&searchText=${searchText}&searchStatus=${searchStatus}&orderType=${orderType}&orderBy=${orderBy}`,
  );
  return data;
};

const searchOrderDetailList = async (
  offset,
  pageSize,
  pageType,
  searchType,
  startDate,
  endDate,
  searchStatus,
  searchOrderId,
  searchProductName,
  funnel,
  name,
  phone,
  orderType,
  orderBy,
  searchDetailType,
  searchDetail,
  userId,
  settlementId,
) => {
  const { data } = await axios.get(
    `${baseUrl}/userOrder/detailList/search?offset=${offset}&pageSize=${pageSize}&pageType=${pageType}&searchType=${searchType}&startDate=${startDate}&endDate=${endDate}&searchStatus=${searchStatus}&searchOrderId=${searchOrderId}&searchProductName=${searchProductName}&funnel=${funnel}&name=${name}&phone=${phone}&searchDetailType=${searchDetailType}&searchDetail=${searchDetail}&orderType=${orderType}&orderBy=${orderBy}&userId=${userId}&settlementId=${
      settlementId ?? 0
    }`,
  );
  return data;
};

const searchOrderOne = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/getOne`, {
    params: param,
  });
  return data;
};

const getOrderOneByPhone = async (param) => {
  const { data } = await axios.get(`${baseUrl}/userOrder/getOne/phone`, {
    params: param,
  });
  return data;
};

const orderCreate = async (param) => {
  const { data } = await axios.post(`${baseUrl}/userOrder/create`, param);
  return data;
};

const orderEdit = async (param) => {
  const { data } = await axios.post(`${baseUrl}/userOrder/edit/admin`, param);
  return data;
};

const orderStatusEdit = async (param) => {
  const { data } = await axios.post(`${baseUrl}/userOrder/orderStatus`, param);
  return data;
};

const orderStatusEditForDeposit = async (param) => {
  const { data } = await axios.post(`${baseUrl}/userOrder/deposit/paid`, param);
  return data;
};

const orderTrackingNumRegister = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/register/trackingNum`,
    param,
  );
  return data;
};

const orderDeliveryInfoEdit = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/edit/deliveryInfo`,
    param,
  );
  return data;
};

const manualOrderDeliveryInfoEdit = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/edit/manualOrder/deliveryInfo`,
    param,
  );
  return data;
};

const orderDirectlyCancel = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/payment/payment/cancel/all`,
    param,
  );
  return data;
};

const orderCancelInfoEdit = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/edit/cancelInfo`,
    param,
  );
  return data;
};

const isPossibleUploadTrackingNumber = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/isPossibleUploadTrackingNumber`,
    param,
  );
  return data;
};

const refundableOrder = async (param) => {
  const { data } = await axios.post(`${baseUrl}/userOrder/refundable`, param);
  return data;
};

const isLastOrderByOrderId = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/userOrder/isLastOrder/byOrderId`,
    param,
  );
  return data;
};

const isLastOrder = async (param) => {
  const { data } = await axios.post(`${baseUrl}/userOrder/isLastOrder`, param);
  return data;
};

const purchasePointComplete = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/point/admin/purchase/complete`,
    param,
  );
  return data;
};

const purchasePointCancel = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/point/point/purchase/cancel`,
    param,
  );
  return data;
};

const paymentCreateForDeposit = async (param) => {
  const { data } = await axios.post(`${baseUrl}/payment/create`, param);
  return data;
};

const salesManageApi = {
  deliveryCompanyList,
  salesManageStatus,
  searchOrderList,
  searchOrderGiftList,
  searchOrderDetailList,
  searchOrderOne,
  getOrderOneByPhone,
  orderCreate,
  orderEdit,
  orderStatusEdit,
  orderStatusEditForDeposit,
  orderTrackingNumRegister,
  orderDeliveryInfoEdit,
  manualOrderDeliveryInfoEdit,
  orderDirectlyCancel,
  orderCancelInfoEdit,
  isPossibleUploadTrackingNumber,
  refundableOrder,
  isLastOrderByOrderId,
  isLastOrder,
  purchasePointComplete,
  purchasePointCancel,
  paymentCreateForDeposit,
};

export default salesManageApi;
